<template lang="pug">
  v-container.mb-16
    .text-2xl.font-semibold.my-4 Home
    .text-lg.font-semibold.my-4 Loyalty
    v-card.round-lg.pa-4.neutral700.white--text.mb-4(flat)
      .d-flex.align-center.mb-2
        v-icon(color="white") $yzi-users-03
        v-progress-circular(v-if="stats.isFetching" indeterminate color="primary" width="2" size="20")
        .text-lg.font-semibold.ml-2(v-else)
          .d-flex.align-center.danger500--text(v-if="stats.isError")
            v-icon(color="danger500" size="15") mdi-alert-circle-outline
            span.ml-1 Error
          span(v-else) {{ stats.data.registered_members | displayNumber }}
      .text-md.font-semibold Registered members
    v-row(no-gutters)
      v-col
        v-card.round-lg.pa-4.neutral200.card-border(outlined)
          .text-sm.font-semibold.neutral500--text.mb-2 {{ settings.loyalty_system | capitalize }} collected
          v-progress-circular(v-if="stats.isFetching" indeterminate color="primary" width="2" size="20")
          .text-md.font-semibold(v-else)
            .d-flex.align-center.danger500--text(v-if="stats.isError")
              v-icon(color="danger500" size="15") mdi-alert-circle-outline
              span.ml-1 Error
            span(v-else) {{ stats.data.collected_count | displayNumber }}
      .mx-2
      v-col
        v-card.round-lg.pa-4.neutral200.card-border(outlined)
          .text-sm.font-semibold.neutral500--text.mb-2 Rewards redeemed
          v-progress-circular(v-if="stats.isFetching" indeterminate color="primary" width="2" size="20")
          .text-md.font-semibold(v-else)
            .d-flex.align-center.danger500--text(v-if="stats.isError")
              v-icon(color="danger500" size="15") mdi-alert-circle-outline
              span.ml-1 Error
            span(v-else) {{ stats.data.redeemed_count | displayNumber }}
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      stats: {
        isFetching: true,
        isError: false,
        data: null
      }
    }
  },
  mounted() {
    this.fetchStats()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      settings: 'marketing/getMarketingSettings',
    }),
  },
  methods: {
    async fetchStats() {
      try {
        this.stats.isFetching = true
        const {data} = await this.$axios.get(`/loyalty/${this.company.slug}/overview`)
        this.stats.data = data
      } catch {
        this.stats.isError = true
      } finally {
        this.stats.isFetching = false
      }
    }
  },
}
</script>

<style scoped>
.card-border {
  border: 1px solid #EEEEEE !important;
}
</style>